// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-m_eO","advertDetailHeaderLocation__value":"c-m_eP"};